import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from 'react';
import { Nav, Container, Row, Col, Button, Modal } from 'react-bootstrap';


function ReportGroup({ dados }) {

    const [showModal, setShowModal] = useState(false);
    const [activeData, setActiveData] = useState();
    const [titleModal, setTitleModal] = useState('');

    const types =
    {
        "Possui Débitos de Tributos Federais?": "Governança",
        "Possui Parcelamentos de Tributos Federais?": "Governança",
        "Possui Inscrição no CEIS?": "Governança",
        "Possui Inscrição no CNEP?": "Governança",
        "Possui Débitos de FGTS?": "Social",
        "Possui Débitos de Contribuição Previdenciária (INSS)?": "Social",
        "Possui Acidentes de Trabalho?": "Social",
        "Possui Investigações do MPT?": "Social",
        "Está na Lista Suja do Trabalho Escravo?": "Social",
        "Possui Autos de Infração emitidos pelo IBAMA?": "Ambiental",
        "Possui Autos de Infração emitidos pela SEMAD/MG?": "Ambiental"
    }

    const typesMatriz =
    {
        "ambiental": "Ambiental",
        "IBAMA": "Ambiental",
        "CTF/IBAMA": "Ambiental",
        "RAPP": "Ambiental",
        "resíduos": "Ambiental",
        "resíduo": "Ambiental",
        "órgão ambiental": "Ambiental",
        "Autuação pelo órgão ambiental": "Ambiental",
        "Lançamento de efluentes": "Ambiental",
        "Geração de resíduos": "Ambiental",
        "Débito de Contribuição": "Social",
        "Investigação": "Social",
        "Inquérito": "Social",
        "Acidente de trabalho": "Social",
        "Débito de tributos": "Governança",
        "Acidente de trabalho registrado junto ao INSS": "Social",
        "Autuação pelo IBAMA": "Ambiental",
        "Autuação pelo IBAMA com aplicação de multa pecuniária": "Ambiental",
        "Débito de tributos federais": "Governança",
        "Débito de tributos federais por relevância de valor": "Governança",
        "Investigação / Inquérito no âmbito do MPT": "Social",
        "Débito de Contribuição Previdenciária (INSS)": "Social",
        "Débito de Contribuição Previdenciária (INSS) por relevância de valor": "Social",
        "Situação cadastral inativa do CNPJ": "Governança",
        "Autuação pelo órgão ambiental estadual de MG com suspensão ou embargo de atividade": "Ambiental",
        "Situação cadastral irregular para destinação de resíduo no CTF/IBAMA": "Ambiental",
        "Destinação de resíduo inconsistente no RAPP do CTF/IBAMA": "Ambiental",
        "Geração de resíduos com grande variância no RAPP do CTF/IBAMA": "Ambiental",
        "Geração de resíduos inconsistente no RAPP do CTF/IBAMA": "Ambiental",
        "Autuação pelo órgão ambiental estadual de MG": "Ambiental",
        "Autuação pelo órgão ambiental estadual de MG com aplicação de multa pecuniária": "Ambiental",
        "Lançamento de efluentes inconsistente no RAPP do CTF/IBAMA": "Ambiental",
        "Lançamento de efluentes atmosféricos com grande variância no RAPP do CTF/IBAMA": "Ambiental",
        "Lançamento de efluentes em corpo hídrico de classe especial no RAPP do CTF/IBAMA": "Ambiental",
        "Destinação de resíduo com grande variância no RAPP do CTF/IBAMA": "Ambiental",
        "Autuação pelo IBAMA nos últimos 5 anos": "Ambiental",
        "Termo de Ajustamento de Conduta firmado com o órgão ambiental estadual de MG": "Ambiental",
        "Intervenção ambiental negada pelo órgão ambiental estadual de MG": "Ambiental",
        "Outorga de recursos hídricos deferida pelo órgão ambiental estadual de MG": "Ambiental",
        "Licenciamento ambiental negado pelo órgão ambiental estadual de MG": "Ambiental",
        "Término de atividade no CTF/APP IBAMA": "Ambiental",
        "Fonte energética inconsistente no RAPP do CTF/IBAMA": "Ambiental",
        "Tratamento de efluentes lançados com baixa eficácia no RAPP do CTF/IBAMA": "Ambiental",
    }

    useEffect(() => {
        const coll = document.getElementsByClassName("collapsible");
        let i;

        for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener('click', function() {
            this.classList.toggle('active');
            const content = this.nextElementSibling;

            if (content.classList.contains('show')) {
                content.classList.remove('show');
            } else {
                content.classList.add('show');;
            }
        });
        }
        // const collapseElementList = document.querySelectorAll('.collapse')
        // const collapseList = [...collapseElementList].map(collapseEl => new bootstrap.Collapse(collapseEl))
        // dados['iESGscan Score da Matriz'] = '3.0';
        // dados["Alguns Riscos da Matriz"] = [
        //     "Acidente de trabalho registrado junto ao INSS",
        //     "Autua\u00e7\u00e3o pelo IBAMA",
        //     "Autua\u00e7\u00e3o pelo IBAMA com aplica\u00e7\u00e3o de multa pecuni\u00e1ria",
        //     "D\u00e9bito de tributos federais",
        //     "D\u00e9bito de tributos federais por relev\u00e2ncia de valor",
        //     "Investiga\u00e7\u00e3o / Inqu\u00e9rito no \u00e2mbito do MPT"
        // ]

        // dados["Riscos em Cadeia da Estrutura Societária - CNPJs"] = [
        //     {
        //         "CNPJ": "05.470.466/0001-74",
        //         "Raz\u00e3o Social": "VALLOUREC TUBES",
        //         "Possui D\u00e9bitos de Tributos Federais?": "N\u00e3o",
        //         "Possui Parcelamentos de Tributos Federais?": "N\u00e3o",
        //         "Possui Inscri\u00e7\u00e3o no CEIS?": "N\u00e3o",
        //         "Possui Inscri\u00e7\u00e3o no CNEP?": "N\u00e3o",
        //         "Possui D\u00e9bitos de FGTS?": "N\u00e3o",
        //         "Possui D\u00e9bitos de Contribui\u00e7\u00e3o Previdenci\u00e1ria (INSS)?": "N\u00e3o",
        //         "Possui Acidentes de Trabalho?": "N\u00e3o",
        //         "Possui Investiga\u00e7\u00f5es do MPT?": "N\u00e3o",
        //         "Est\u00e1 na Lista Suja do Trabalho Escravo?": "N\u00e3o",
        //         "Possui Autos de Infra\u00e7\u00e3o emitidos pelo IBAMA?": "N\u00e3o",
        //         "Possui Autos de Infra\u00e7\u00e3o emitidos pela SEMAD/MG?": "N\u00e3o"
        //     }
        // ]

        // dados["Quadro de Sócios e Administradores do CNPJ | Receita Federal do Brasil (RFB)"] = [
        //     {
        //         "Nome do S\u00f3cio": "VALLOUREC TUBES",
        //         "Identificador": "Pessoa Jur\u00eddica",
        //         "CNPJ": "05.470.466/0001-74",
        //         "Qualifica\u00e7\u00e3o": "S\u00f3cio Pessoa Jur\u00eddica Domiciliado no Exterior",
        //         "Data de Entrada na Sociedade": "05/03/2018",
        //         "Nome do Representante Legal": "HUDSON FERNANDO COUTO",
        //         "CPF do Representante Legal": "***.761.956-**",
        //         "Qualifica\u00e7\u00e3o do Representante Legal": "Procurador"
        //     },
        //     {
        //         "Nome do S\u00f3cio": "MARCIO ADRIANI PIRES DAMAZIO",
        //         "Identificador": "Pessoa F\u00edsica",
        //         "CPF": "***.034.336-**",
        //         "Qualifica\u00e7\u00e3o": "Administrador",
        //         "Data de Entrada na Sociedade": "11/10/2023",
        //         "\u00c9 Pessoa Politicamente Exposta (PEP)?": "N\u00e3o"
        //     },
        //     {
        //         "Nome do S\u00f3cio": "JUN MUTO",
        //         "Identificador": "Pessoa F\u00edsica",
        //         "CPF": "***.943.752-**",
        //         "Qualifica\u00e7\u00e3o": "Administrador",
        //         "Data de Entrada na Sociedade": "27/12/2023",
        //         "\u00c9 Pessoa Politicamente Exposta (PEP)?": "N\u00e3o"
        //     }
        // ]

    })

    const handleClickInfo = (data, title) => {
        setActiveData(data);
        setTitleModal(title);
        setShowModal(true);
    }

    return (
        <>
            <Row className='d-flex scrollbar mt-3 pt-4' style={{ height: 'calc(100vh - 500px)' }}>
                <Col md={3}>
                    {dados && dados['Comprovante de Inscrição e de Situação Cadastral do CNPJ | Receita Federal do Brasil (RFB)'] && dados['Comprovante de Inscrição e de Situação Cadastral do CNPJ | Receita Federal do Brasil (RFB)'].length > 0 && (
                        <div className='rect-content-risks mt-3' style={{ width: '90%' }}>
                            <div className='rect-header' style={{ fontSize: '64px', top: '-50px' }}>
                                <i className='bi bi-credit-card-2-front-fill color-secondary'></i>
                            </div>
                            <p className='rect-tx-1 mt-4'>Comprovante de Inscrição e de Situação Cadastral do CNPJ Receita Federal do Brasil (RFB)</p>
                            <div className='rect-link cursor-pointer' onClick={() => handleClickInfo(dados['Comprovante de Inscrição e de Situação Cadastral do CNPJ | Receita Federal do Brasil (RFB)'], 'Comprovante de Inscrição e de Situação Cadastral do CNPJ | Receita Federal do Brasil (RFB)')}><i className="bi bi-plus-circle-fill"></i></div>
                        </div>
                    )}
                    {dados && dados['Quadro de Sócios e Administradores do CNPJ | Receita Federal do Brasil (RFB)'] && dados['Quadro de Sócios e Administradores do CNPJ | Receita Federal do Brasil (RFB)'].length > 0 && (
                        <div className='rect-content-risks mt-5' style={{ width: '90%' }}>
                            <div className='rect-header' style={{ fontSize: '64px', top: '-50px' }}>
                                <i className='bi bi-people-fill color-secondary'></i>
                            </div>
                            <p className='rect-tx-1 mt-4'>Quadro de Sócios e Administradores do CNPJ Receita Federal do Brasil (RFB)</p>
                            <div className='rect-link cursor-pointer' onClick={() => handleClickInfo(dados['Quadro de Sócios e Administradores do CNPJ | Receita Federal do Brasil (RFB)'], 'Quadro de Sócios e Administradores do CNPJ | Receita Federal do Brasil (RFB)')}><i className="bi bi-plus-circle-fill"></i></div>
                        </div>
                    )}
                    {/* {dados && dados.CNPJ && dados['Outros CNPJs dos Sócios Pessoa Jurídica'] && dados['Outros CNPJs dos Sócios Pessoa Jurídica'].length > 0 && (
                        <div className='rect-content-risks mt-5' style={{ width: '90%' }}>
                            <div className='rect-header' style={{ fontSize: '64px', top: '-50px' }}>
                                <i className='bi bi-person-vcard-fill color-secondary'></i>
                            </div>
                            <p className='rect-tx-1 mt-4'>Outros CNPJs dos Sócios | Receita Federal do Brasil (RFB)</p>
                            <div className='rect-link cursor-pointer' onClick={() => handleClickInfo(dados['Outros CNPJs dos Sócios Pessoa Jurídica'], 'Outros CNPJs dos Sócios | Receita Federal do Brasil (RFB)')}><i className="bi bi-plus-circle-fill"></i></div>
                        </div>
                    )}
                    {dados && dados.CPF && dados['Outros CNPJs dos Sócios Pessoa Física'] && dados['Outros CNPJs dos Sócios Pessoa Física'].length > 0 && (
                        <div className='rect-content-risks mt-5' style={{ width: '90%' }}>
                            <div className='rect-header' style={{ fontSize: '64px', top: '-50px' }}>
                                <i className='bi bi-person-vcard-fill color-secondary'></i>
                            </div>
                            <p className='rect-tx-1 mt-4'>Outros CNPJs dos Sócios | Receita Federal do Brasil (RFB)</p>
                            <div className='rect-link cursor-pointer' onClick={() => handleClickInfo(dados['Outros CNPJs dos Sócios Pessoa Física'], 'Outros CNPJs dos Sócios | Receita Federal do Brasil (RFB)')}><i className="bi bi-plus-circle-fill"></i></div>
                        </div>
                    )} */}
                </Col>
                {dados['iESGscan Score da Matriz'] || (dados['Filiais que Possuem Maiores Riscos'] && Object.keys(dados['Filiais que Possuem Maiores Riscos']).length > 0) ?

                    <Col md={3}>
                        {dados['iESGscan Score da Matriz'] &&
                            <>
                                <div className='rect-content-risks mt-3 d-flex justify-content-between  align-items-center' style={{ height: 'auto', width: '100%' }}>
                                <span className='rect-tx-1'>Score da Matriz <br /><small>{dados['CNPJ da Matriz'] ? 'CNPJ :  ' + dados['CNPJ da Matriz'] : ""}</small></span><div className='rect-tag social small fs-6 p-0' style={{ width: '55px' }}>{dados['iESGscan Score da Matriz']}</div>
                                </div>
                            </>
                        }
                        {dados['Filiais que Possuem Maiores Riscos'] && Object.keys(dados['Filiais que Possuem Maiores Riscos']).length > 0 &&
                            <>
                                <h6 style={{ width: '50%' }}>Filiais com maior score</h6>
                                {Object.keys(dados['Filiais que Possuem Maiores Riscos']).map((key, index) => (
                                    <div key={index} className='rect-content-risks mt-3 d-flex justify-content-between' style={{ height: 'auto', width: '100%' }}>
                                        <span className='rect-tx-1'>{key}</span><div className='rect-tag social small fs-6 p-0' style={{ width: '55px' }}>{dados['Filiais que Possuem Maiores Riscos'][key]}</div>
                                    </div>
                                ))}
                            </>
                        }
                    </Col>
                    : ''}
                <Col md={6}>
                    {dados['Alguns Riscos da Matriz'] && dados['Alguns Riscos da Matriz'].length > 0 &&
                        <>
                            <h6 className='mb-4' style={{ width: 'fit-content' }}>Alguns Riscos da Matriz</h6>

                            <>

                                <table className="table" style={{ marginTop: '-9px', marginLeft: '15px' }}>
                                    <tbody>
                                    {dados['Alguns Riscos da Matriz'].map((item, i) => (
                                            typesMatriz[item] && (
                                                <tr key={item + i}>
                                                    <td>{(i + 1)}. {item}</td>
                                                    <td><div className={'rect-tag small ' + typesMatriz[item].replace('ç', 'c').toLowerCase()}>{typesMatriz[item]}</div></td>
                                                </tr>
                                            )
                                        ))}
                                    </tbody>
                                </table>
                            </>

                        </>
                    }
                    {dados['Riscos em Cadeia da Estrutura Societária - CNPJs'] && dados['Riscos em Cadeia da Estrutura Societária - CNPJs'].length > 0 &&
                        <>
                            <h6 className='mb-4' style={{ width: 'fit-content' }}>Riscos em Cadeia da Estrutura Societária CNPJs | Receita Federal do Brasil (RFB)</h6>
                            {dados['Riscos em Cadeia da Estrutura Societária - CNPJs'].map((item, index) =>
                                <div key={'nosoc-' + index}>
                                    <div key={item + index} className='list-residuos d-flex justify-content-between collapsible cursor-pointer' style={{ marginLeft: '15px' }}>
                                        <span>{index + 1 + '.'} {item['Razão Social']} ({item.CNPJ})</span> <i className='bi bi-chevron-down'></i> <i className='bi bi-chevron-right'></i>
                                    </div>
                                    <div className="collapse">
                                        <table className="table" style={{ marginTop: '-9px', marginLeft: '15px' }}>
                                            <tbody>
                                                {dados['Riscos em Cadeia da Estrutura Societária - CNPJs'][index] && Object.keys(dados['Riscos em Cadeia da Estrutura Societária - CNPJs'][index]).length > 0 && Object.keys(dados['Riscos em Cadeia da Estrutura Societária - CNPJs'][index]).map((key, i) => (
                                                    key.toString().indexOf('?') > -1 && (
                                                        <tr key={'risc-' + i}>
                                                            <td>{(index + 1) + '.' + (i - 1) + '.'} {key}</td>
                                                            <td><div className={'rect-tag small ' + types[key].replace('ç', 'c').toLowerCase()}>{types[key]}</div></td>
                                                            <td><b className={dados['Riscos em Cadeia da Estrutura Societária - CNPJs'][index][key] === 'Sim' ? 'text-red-700' : ''}>{dados['Riscos em Cadeia da Estrutura Societária - CNPJs'][index][key]}</b></td>
                                                        </tr>
                                                    )
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </>
                    }
                    {dados['Riscos em Cadeia da Estrutura Societária - CNPJs Sócios'] && dados['Riscos em Cadeia da Estrutura Societária - CNPJs Sócios'].length > 0 &&
                        <>
                            <h6 className='mb-4' style={{ width: 'fit-content' }}>Riscos em Cadeia da Estrutura Societária CNPJs Sócios | Receita Federal do Brasil (RFB)</h6>
                            {dados['Riscos em Cadeia da Estrutura Societária - CNPJs Sócios'].map((item, index) =>
                                <div key={'soc-' + index}>
                                    <div className='list-residuos d-flex justify-content-between collapsible cursor-pointer' style={{ marginLeft: '15px' }}>
                                        <span>{index + 1 + '.'} {item['Razão Social']} ({item.CNPJ})</span> <i className='bi bi-chevron-down'></i> <i className='bi bi-chevron-right'></i>
                                    </div>
                                    <div className='collapse'>
                                        <table className="table" style={{ marginTop: '-9px', marginLeft: '15px' }}>
                                            <tbody>
                                                {dados['Riscos em Cadeia da Estrutura Societária - CNPJs Sócios'][index] && Object.keys(dados['Riscos em Cadeia da Estrutura Societária - CNPJs Sócios'][index]).length > 0 && Object.keys(dados['Riscos em Cadeia da Estrutura Societária - CNPJs Sócios'][index]).map((key, i) => (
                                                    key.toString().indexOf('?') > -1 && (
                                                        <tr key={i}>
                                                            <td>{(index + 1) + '.' + (i - 1) + '.'} {key}</td>
                                                            <td><div className={'rect-tag small ' + types[key].replace('ç', 'c').toLowerCase()}>{types[key]}</div></td>
                                                            <td><b className={dados['Riscos em Cadeia da Estrutura Societária - CNPJs Sócios'][index][key] === 'Sim' ? 'text-red-700' : ''}>{dados['Riscos em Cadeia da Estrutura Societária - CNPJs Sócios'][index][key]}</b></td>
                                                        </tr>
                                                    )
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </>
                    }
                </Col>
            </Row>
            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {activeData && (
                        <>
                            <p className='rect-tx-1 fs-5' title={titleModal}>{titleModal}</p>
                            {activeData && activeData.length > 0 && activeData.map((item, i) => (
                                <div className='mb-5'>
                                    {item && Object.keys(item).length > 0 && Object.keys(item).map((key, i) => (
                                        key === 'Nome do Sócio' || key === 'Nome' || key === 'CNPJ' ? <div className='mb-2 color-tertiary'><b>{key}</b>: {item[key]}</div> :
                                            !Array.isArray(item[key]) ? <div><b>{key}</b>: {item[key]}</div> : 
                                                
                                            item[key] && item[key].length > 0 && item[key].map((data, i) => (
                                                <div className='mb-5 ms-3'>
                                                    {data && Object.keys(data).length > 0 && Object.keys(data).map((key, i) => (
                                                        key === 'Razão Social' || key === 'CNPJ da Matriz' ? <div className='mb-1 color-secondary'><b>{key}</b>: {data[key]}</div> :
                                                            !Array.isArray(data[key]) ? <div><b>{key}</b>: {data[key]}</div> : 'array'
                                                    ))}
                                                </div>
                                            ))
                                    ))}
                                </div>
                            ))}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button className='small' variant="secondary" onClick={(e) => setShowModal(false)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ReportGroup;